<template>
  <v-dialog
    v-model="dialog"
  >
    <v-card>
      <v-card-title>
        Equiped weapons by Tension Beats
      </v-card-title>
      <v-card-text v-if="loading" class="text-center">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        />
      </v-card-text>
      <v-card-text v-else>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th rowspan="2" class="text-left"></th>
                <th
                  v-for="value in tensionBeats"
                  :key="value"
                  class="text-center"
                  colspan="2"
                >
                  {{ value }}
                </th>
              </tr>
              <tr>
                <template v-for="value in tensionBeats">
                  <th :key="`${value}-per-session`" class="text-center">
                    per Session
                  </th>
                  <th :key="`${value}-total`" class="text-center">
                    Total
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-if="items.length === 0">
                <td class="text-center caption" colspan="3">No data</td>
              </tr>
              <template v-else>
                <tr
                  v-for="item in items"
                  :key="item.name"
                >
                  <td class="caption">{{ item.name }}</td>
                  <template v-for="value in tensionBeats">
                    <td :key="`${value}-${item.key}-per-session-body`" class="caption text-center">
                      {{ item[value] ? timeToString((item[value].val * 1000) / (item[value].players || 1)) : '00:00:00' }}
                    </td>
                    <td :key="`${item.tension_beat}-${value}-total-body`" class="caption text-center">
                      {{ item[value] ? timeToString(item[value].val * 1000) : '00:00:00' }}
                    </td>
                  </template>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import helper from '../../../plugins/helpers/mixin-helper';
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      dialog: true,
      loading: true,
      tensionBeats: [],
      items: []
    }
  },
  watch: {
    dialog (val) {
      if (!val) {
        setTimeout(() => {
          this.$emit('close')
        }, 500)
      }
    },
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-equiped-weapon/tension-beats`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.items = data.data
        this.tensionBeats = data.tensionBeats
      }
      this.loading = false
    }
  }
}
</script>